import React from "react";
import Questions_Table_MEDAS from "./table";
import { Container } from "react-bootstrap";
import data from "./medas.json"; // your JSON file with the extracted questions

class MEDAS extends React.Component {
  constructor(props) {
    super();
    this.state = {};
  }

  handleTableChange = async (newState) => {
    await this.setState({ ...newState });
    if (this.props.handler) {
      this.props.handler("medas", this.state);
    }
  };

  async componentDidMount() {
    if (this.props.data) {
      await this.setState(this.props.data);
    }
  }

  render() {
    return (
      <Container>
        <Questions_Table_MEDAS
          questions={data}
          data={this.props.data || {}}
          handler={this.handleTableChange}
          disabled={this.props.disabled}
        />
      </Container>
    );
  }
}

export default MEDAS;

MEDAS.defaultProps = {
  handler: null,
  disabled: false,
};
